import Footer from "components/Footers/Footer";
import Navbar from "components/Navbars/AuthNavbar";
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const ViewSubUser = ({ location }) => {
  const history = useHistory();

  useEffect(() => {
    // Check if user is not logged in (localStorage is empty)
    if (!localStorage.getItem("userData")) {
      // Redirect to the login page
      history.push("/login");
    }
  }, [history]);

  const { user } = location.state || {};

  return (
    <>
      <Navbar />
      <div className="cust-div" style={{ minHeight: "550px" }}>
        <div className="container mx-auto mt-8 p-4">
          <h2 className="text-2xl font-bold mb-4"></h2>
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-2xl  font-bold">Sub User Details</h1>
            <div>
              <button
                className="bg-lightBlue-500 text-white active:bg-lightBlue-600 mr-3 text-xs font-bold uppercase px-4 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"
                type="button"
                onClick={() => history.goBack()}
              >
                <i
                  className="fa fa-arrow-circle-left mr-1"
                  title="Go To Sub Users"
                ></i>
              </button>
            </div>
          </div>
          {user ? (
            <div>
              <p>
                <strong>Full Name:</strong> {user.fullName}
              </p>
              <p>
                <strong>User Name:</strong> {user.userName}
              </p>
              <p>
                <strong>Email Address:</strong> {user.emailId}
              </p>
              {/* Add other user details as needed */}
            </div>
          ) : (
            <p>No user data available.</p>
          )}
        </div>
      </div>

      <Footer />
    </>
  );
};

export default ViewSubUser;
